import React from "react";
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import './Alertsuccess.css';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import AuthService from '../Services/auth.service';
class Alertsuccess extends React.Component {

    constructor(props){
        super(props);
        
    }
    removeAddress(){

        const dltData= {
            name:this.props.deletename
            
          }
        
        const USR_TOKEN = localStorage.getItem("userToken")
          if(USR_TOKEN){
            //alert(USR_TOKEN)
              const user =  AuthService.getCurrentUser();
              this.setState({profile:user})
              axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.delete_address',dltData,{
                headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
                'content-type': 'application/json'}  
          })     
        .then( 
            
            res =>{  console.log(res) 
              this.props.latest();
              this.props.alertcancel('false')
              toast.success("Address Deleted")
            }
                
        )
        
        .catch(
            
            err =>{ console.log(err)
              //alert("unable to delete")
              toast.error("unable to delete")
            }
        )
          }
          else{
            alert("Not Logged in")
        }

    }
  render() {
    return <div className="">
            <Toaster
              position="top-center"
              reverseOrder={false}
              className="px-6 py-4"
              style={{ width: "13rem"}}
            />
                <div className="col-md-12"> 
                    <div className="row">
                        <div className="col-md-12 alert-s-pop-message"> 
                            <p>{this.props.alertmessage}</p>
                            {
                                (() => {
                                    if (this.props.alertmessage==="Delete Address?")
                                        return  <div className="del-btn-allign">
                                                    <button type="button" className=" confirm-btns alert-d-btn ml-3" onClick={() => this.props.alertcancel('false')}>Cancel</button>
                                                    <button type="button" className=" confirm-btns alert-d-btn" onClick={() =>  this.removeAddress()} >Ok</button>
                                                </div>
                                    else if(this.props.alertmessage==="New Address Added")
                                        return <button type="button" className=" add-to-cart2 alert-s-btn" onClick={() => window.location.href ='/my-profile' }>Ok</button>
                                    else if(this.props.alertmessage==="Please Signup")
                                        return <button type="button" className=" add-to-cart2 alert-s-btn" onClick={() => window.location.href ='/'}>Ok</button>
                                    else
                                        return""
                                })()
                            }
                        </div>
                    </div>
                </div>

  

    </div>
    }
}

export default Alertsuccess;
